import { Badge } from "@/components/ui/badge";
import { SubscriptionStatus } from "@/types/enums";
import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  status: SubscriptionStatus;
  className?: string;
}

const STATUS_CONFIG: Record<
  SubscriptionStatus,
  {
    label: string;
    variant: "default" | "secondary" | "destructive" | "outline";
    className: string;
  }
> = {
  [SubscriptionStatus.ACTIVE]: {
    label: "활성",
    variant: "default",
    className: "bg-emerald-100 text-emerald-800 border-emerald-300",
  },
  [SubscriptionStatus.PENDING_PAYMENT]: {
    label: "결제 대기",
    variant: "outline",
    className: "bg-amber-100 text-amber-800 border-amber-300",
  },
  [SubscriptionStatus.PENDING_CANCELLATION]: {
    label: "해지 대기",
    variant: "secondary",
    className: "bg-orange-100 text-orange-800 border-orange-300",
  },
  [SubscriptionStatus.PENDING_PLAN_CHANGE]: {
    label: "플랜 변경 대기",
    variant: "outline",
    className: "bg-sky-100 text-sky-800 border-sky-300",
  },
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status];

  return (
    <Badge
      variant={config.variant}
      className={cn(config.className, className)}
      aria-label={`Status: ${config.label}`}
    >
      {config.label}
    </Badge>
  );
}
